import { z } from "zod";

const productSchema = z.object({
  upc: z.string(),
  name: z.string(),
});

const homeLocationSchema = z.object({
  name: z.string(),
  products: z.array(productSchema),
});

export const homeLocationsResponseSchema = z.array(homeLocationSchema);

export type IProduct = z.infer<typeof productSchema>;
export type IHomeLocation = z.infer<typeof homeLocationSchema>;

export interface RestructuredLocationData {
  [locationName: string]: IProduct[];
}
